module.exports = __webpack_public_path__ + "public/images/TrustAndSafety_2023_HappyKey_200x200_Waterslide.3e2152b457f3ad0b12955aab5887ff43.png";